import { Container } from './App.style'
import DataTable from './components/DataTable'

const App = () => {
  return (
    <Container>
      <DataTable />
    </Container>
  )
}

export default App
